import React from 'react';

const EventDetailsWhatsNew = () => {
  return (
    <div>
      <h2>Whats New</h2>
    </div>
  );
};

export default EventDetailsWhatsNew;
